import { render, staticRenderFns } from "./CorrespondenceThreadsFiltering.vue?vue&type=template&id=17e02fa8&scoped=true&"
import script from "./CorrespondenceThreadsFiltering.vue?vue&type=script&lang=js&"
export * from "./CorrespondenceThreadsFiltering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e02fa8",
  null
  
)

export default component.exports